let parameters = {
  chartDataSource: {
      label: 'Chart Data',
      class: 'xs12 sm12 d-flex',
      type: 'select',
      source: 'dataSources',
      itemValue: 'id',
      itemText: 'name',
      items: [],
      item: {data: [], headers: []},
      wait: true
  },
    title: {
        label: 'Title',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false,
        value: ''
    },
    xAxisLabel: {
        label: 'X Axis Label',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false,
        value: ''
    },
    yAxisLabel: {
        label: 'Y Axis Label',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false,
        value: ''
    },
    size: {
        label: 'Size',
        class: 'xs6 d-flex',
        type: 'input',
        wait: false,
        value: 80
    },
    speed: {
        label: 'Speed',
        class: 'xs6 d-flex',
        type: 'input',
        wait: false,
        value: 1000
    },
    symbol: {
        label: 'Symbol',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false,
        value: ''
    },
    labelPosition: {
        label: 'Label Pos. (inside,top,right..)',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false,
        value: 'inside'
    },
    labelFontSize: {
        label: 'Label Font Size',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false,
        value: 12
    },
    backgroundColor: {
        label: 'Background Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    color: {
        label: 'Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    timelineColor: {
        label: 'Timeline Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    timelineTitleSize: {
        label: 'Title Size',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    timelineTitleColor: {
        label: 'Title Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    timelineLegendTop: {
        label: 'Title Top',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    timelineLegendLeft: {
        label: 'Title Left',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    axisLineColor: {
        label: 'Axis Line Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    },
    axisFontColor: {
        label: 'Axis Font Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        wait: true,
        value: ''
    }
};

export default parameters;
